// extracted by mini-css-extract-plugin
module.exports = {"pictureContainer":"SellerProductDetailFormModal_pictureContainer__2PgmW","pictureOuterContainer":"SellerProductDetailFormModal_pictureOuterContainer__1vHLr"};